import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CognitoService } from '../../services/cognito/cognito.service';
import { LoginService } from './login.service';
import { ModuleWithProviders } from '@angular/compiler/src/core';
import { RegionsListGuard } from './regions-list-guard';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule
  ],
  declarations: [
    LoginComponent
  ],
  exports: [
    LoginComponent
  ]
})
export class LoginModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: LoginModule,
      providers: [
        CognitoService,
        LoginService,
        RegionsListGuard
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/login/login.module.ts